/**
 * 업체 요청으로 가격, 비용정보를 노출하지 않는 장지 시설 id.
 *
 * "해당 업체의 요청에 의해 가격, 비용정보, 후기, 사진 등의 정보를 제공하지 않습니다" 안내로
 * 대체된다. 계약상 약속이라 가격이 새는 경로가 하나라도 남으면 안 된다.
 *
 * 화면 본문뿐 아니라 **meta description, JSON-LD, 견적 퍼널의 비용 게이지까지** 전부 막아야 한다.
 * 새로 가격을 표시하는 화면을 만들 때 이 목록을 반드시 통과시킬 것.
 *
 * platform 과 parlor 가 같은 시설을 다루므로 goi_common 에 둔다. platform 에만 두고
 * parlor 는 다른 방식으로 막았더니, 지역 페이지 장지 카드에서 8곳의 요금이 그대로
 * 노출됐다. 앱마다 목록을 복사하면 계약 시설이 늘어날 때 한쪽을 빠뜨린다.
 * platform 의 constants/facility/excludeFacilities 는 기존 import 경로 유지용
 * re-export 로 남아 있다.
 */
export const excludeFacilities = [
  "5",
  "10",
  "150",
  "174",
  "189",
  "200",
  "232",
  "433",
  "554",
  "702",
  "832",
  "993",
  "1028",
];
